<template>
    <main data-type="top-level-container" class="main-area">
        <div id="status" />
        <slot name="header" />
        <nuxt-page />
        <template
            v-for="(item, index) in customModals"
            :key="index"    
        >
            <component
                :is="item.component"
                v-if="item.isShown"
                :title="item.title"
                :message="item.message"
                :buttons="item.buttons"
                :name="item.name"
                :api-message="item.apiMessage"
                :loading="item.loading"
                :focused-ind="item.focusedInd"
                @on-btn-click="item.clickHandler"
                @close="item.closeHandler"
            />
        </template>
        <template
            v-for="(item, index) in defaultModals"
            :key="index"    
        >
            <component
                :is="item.component"
                v-if="item.isShown"
                @on-btn-click="item.clickHandler"
                @close="item.closeHandler"
            />
        </template>
        <Page-Loading-Indicator v-show="getIsLoadingPageIndicator"/>

        <!--test event Modal For testing amazon fizz--->
        <div v-if="isAmazon" id="eventTestModal" class="eventTestModal"/>
    </main>
</template>

<script setup lang="ts">
    import { useOnline } from '@vueuse/core';
    import { useGlobalModals } from "@/composables/globalModals/useGlobalModals";
    import { useParentControl } from "@/composables/parentControl/useParentControl";
    import { useApplicationStore } from "@/stores/Application";
    import { storeToRefs } from 'pinia';
    import { useUserInfoStore } from "@/stores/UserInfo";
    import { useUserSettingsStore } from "@/stores/UserSettings";
    import { useParentControlStore } from "@/stores/ParentControl";
    import { isAmazon } from "@ca.vmedia.tv/domains";

    const { SetEnabledAutoplay } = useUserSettingsStore();
    const ParentControlStoreModule = useParentControlStore();
    const {
        HideParentModal
    } = ParentControlStoreModule;
    const {
        getIsAdultPinCorrect: isAdultPinCorrect,
    } = storeToRefs(ParentControlStoreModule);

    const UserInfoStoreModule = useUserInfoStore();
    const {
        isClient,
    } = storeToRefs(UserInfoStoreModule);
    
    const ApplicationStore = useApplicationStore();
    const { getIsLoadingPageIndicator } = storeToRefs(ApplicationStore);
    const { 
        hideHeader: hideHeaderToStore, 
        showInternetModal,
    } = ApplicationStore;

    const { customModals, defaultModals } = useGlobalModals();
    const { setCurrentRating, setCurrentTimes } = useParentControl();
    const { $navigator } = useNuxtApp();

    const isOffline = computed((): boolean => !useOnline().value);

    const hideHeader = (event: HTMLElement | null) => {
        if (event?.dataset.type !== "menu-item") {
            hideHeaderToStore();
        }
    };
    const correctedPin = () => {
        HideParentModal();
    };
    const saveAutoPlay = () => {
        const autoplayLocalStorage = JSON.parse(localStorage.getItem("Player")!);
        let autoPlay = true;
        if (autoplayLocalStorage && !autoplayLocalStorage.autoplay) {
            autoPlay = autoplayLocalStorage.autoplay;
        }
        SetEnabledAutoplay(autoPlay);
    };

    watch(
        isAdultPinCorrect,
        (value: boolean) => {
            if (value) {
                correctedPin();
            }
        }
    );
    watch(
        isOffline,
        (value: boolean): void => {
            showInternetModal(value);
        }
    );

    onMounted(() => {
        $navigator?.on("click", hideHeader);
        saveAutoPlay(); //TODO: It's better to move this to startup plugin
        if (isClient.value) {
            setCurrentRating();
            setCurrentTimes();
        }

        // test event Modal For testing amazon fizz
        if (isAmazon) {
            document.getElementById('eventTestModal')!.textContent = window.navigator.userAgent.toLowerCase();
        }
    });

    onBeforeUnmount(() => {
        $navigator?.off("click", hideHeader);
    });
</script>
